<script setup>
import { computed } from 'vue'
import { useUserStore } from './../authentication/user.store'
const userStore = useUserStore()
const subscribeUrl = 'https://goalbook.com/toolkit-info-2/#plans'
const toolkitBaseUrl = import.meta.env.VITE_TOOLKIT_URL
const subscribeUniversityUrl = `${toolkitBaseUrl}/subscribe/university`
const shareUrl = `${toolkitBaseUrl}/share`

const showLicenseBanner = computed(
  () =>
    userStore.isAuthenticated &&
    !userStore.fetching &&
    !userStore.isSuperAdmin &&
    (!userStore.isEnterprise ||
      !userStore.isPremium ||
      userStore.isEnterpriseEndingSoon ||
      userStore.isLicenseExpired),
)
</script>
<template>
  <div
    v-if="showLicenseBanner"
    role="region"
    aria-label="Subscription status"
    class="w-full bg-orange-50 text-md leading-snug text-base-defaultText"
  >
    <div
      class="mx-auto flex max-w-[1170px] flex-wrap items-center justify-center gap-x-4 gap-y-0.5 px-4 py-2 text-center"
    >
      <span v-if="userStore.isTrial && userStore.daysLeftInLicense > 0" class="m-0">
        <span class="font-bold">{{ userStore.daysLeftInLicense }}</span> days remaining
      </span>
      <span v-else-if="userStore.isIndividual && userStore.isPremium && userStore.isLicenseExpired" class="m-0">
        Subscription ended
      </span>
      <span v-else-if="userStore.isEnterpriseEndingSoon" class="m-0">
        <span class="font-bold">{{ userStore.daysLeftInLicense }}</span> days remaining —
        {{
          userStore.isMultiyear
            ? "Your license will be updated when your organization's multiyear renewal process is complete."
            : 'Please contact your administrator to renew your district membership.'
        }}
      </span>
      <span class="inline space-x-4">
        <a
          v-if="
            (userStore.isTrial && !userStore.universityPartnership) ||
            (userStore.isIndividual && userStore.isPremium)
          "
          :href="subscribeUrl"
          class="font-bold underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-base-defaultText"
          >View Plans</a
        >
        <a
          v-if="userStore.isTrial && userStore.universityPartnership"
          :href="subscribeUniversityUrl"
          class="font-bold underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-base-defaultText"
          >University Membership</a
        >
        <a
          :href="shareUrl"
          class="font-bold underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-base-defaultText"
          >Share Toolkit</a
        >
      </span>
    </div>
  </div>
</template>
